module.exports = __webpack_public_path__ + "static/media/automotu.a0218c13.jpeg";